import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import detail from './components/detail';
import Footer from './components/Footer';
import Home from './components/Home';
// import Coin from './components/Coin';
// import Token from './components/Token';
// import Feature from './components/Feature';
// import Exchange from './components/Exchange';
// import GainerLoser from './components/GainerLoser';
// import Exchangedetail from './components/Exchangedetail';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

/*const routing = (
  <Router>
    <div>
     <Header />
      <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/coins/" component={Coin} />
          <Route exact path="/tokens/" component={Token} />
          <Route exact path="/featured/" component={Feature} />
          <Route exact path="/gainer-losers/" component={GainerLoser} />
          <Route path="/detail/:id" component={detail} />
        </Switch>
      <Footer />
    </div>
  </Router>
)
*/
ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={Home} />
          {/* <Route exact path="/coins/" component={Coin} />
          <Route exact path="/tokens/" component={Token} />
          <Route exact path="/featured/" component={Feature} />
          <Route exact path="/exchange/" component={Exchange} />
          <Route exact path="/gainer-losers/" component={GainerLoser} /> */}
          <Route path="/detail/:id" component={detail} />
          {/* <Route path="/exchangedetail/:id" component={Exchangedetail} /> */}
        </Switch>
         
      </div>
    </Router>
  </I18nextProvider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
